'use client';

/**
 * Preferencia do aviso nativo de chamada entrante (#435), POR DEVICE
 * (localStorage) — mesma semantica de `notification-preferences.ts`: o
 * atendente pode querer aviso no desktop do plantao e nao no notebook de casa.
 *
 * Chave PROPRIA, independente do `push-opt-out` do chat
 * (`use-push-subscription.ts:13`). Quem silenciou as notificacoes do
 * atendimento nao pode, por causa disso, perder uma ligacao — sao duas
 * decisoes diferentes e nao devem compartilhar interruptor.
 */
const STORAGE_KEY = 'voice:incoming-call-notification';

/**
 * Ligada por padrao. Sem permissao concedida nada aparece de qualquer jeito
 * (a permissao so e pedida em gesto do agente), entao "ligado por padrao" so
 * significa "vale a partir do momento em que ele conceder". O que precisa ser
 * lembrado e o desligamento EXPLICITO.
 */
export const DEFAULT_VOICE_CALL_NOTIFICATION_ENABLED = true;

export function readVoiceCallNotificationEnabled(): boolean {
  if (typeof window === 'undefined') return DEFAULT_VOICE_CALL_NOTIFICATION_ENABLED;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return DEFAULT_VOICE_CALL_NOTIFICATION_ENABLED;
    return raw === '1';
  } catch {
    /* localStorage indisponivel — cai no default */
    return DEFAULT_VOICE_CALL_NOTIFICATION_ENABLED;
  }
}

export function writeVoiceCallNotificationEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* modo privado em alguns browsers — perde so a persistencia */
  }
}
